import styled from 'styled-components';
import { COMMON, get, TYPOGRAPHY } from './constants';
import sx from './sx';
const FormGroup = styled.div.withConfig({
  displayName: "FormGroup",
  componentId: "sc-14z6yax-0"
})(["margin:", " 0;font-weight:", ";", ";", ";"], get('space.3'), get('fontWeights.normal'), COMMON, sx);
const FormGroupLabel = styled.label.withConfig({
  displayName: "FormGroup__FormGroupLabel",
  componentId: "sc-14z6yax-1"
})(["display:block;margin:0 0 ", ";font-size:", ";font-weight:", ";", ";", ";", ";"], get('space.2'), get('fontSizes.1'), get('fontWeights.bold'), TYPOGRAPHY, COMMON, sx);
FormGroupLabel.displayName = 'FormGroup.Label';
export default Object.assign(FormGroup, {
  Label: FormGroupLabel
});